import { forwardRef } from 'react';
import { CommonFormFieldProps } from '../CommonFormField';
import { DueDatePicker, DueDatePickerProps } from '../../DueDatePicker';
import { DueDateFormField } from './DueDateFormField';

export type DueDateFieldProps = Omit<DueDatePickerProps, 'error'> &
  Pick<CommonFormFieldProps, 'required' | 'error' | 'loading' | 'error'>;

export const DueDateField = forwardRef<HTMLDivElement, DueDateFieldProps>(
  (
    {
      required,
      error,
      'data-testId': dataTestId = 'DueDateField',
      loading = false,
      rfiCreatedAt,
      ...datePickerProps
    },
    ref,
  ) => (
    <DueDateFormField
      required={required}
      error={error}
      data-testid={dataTestId}
      loading={loading}
      rfiCreatedAt={rfiCreatedAt}
      ref={ref}
    >
      <DueDatePicker
        disablePastDates
        rfiCreatedAt={rfiCreatedAt}
        error={!!error}
        {...datePickerProps}
      />
    </DueDateFormField>
  ),
);
